import { render, staticRenderFns } from "./footerMenuExternal.vue?vue&type=template&id=fa4918d6&scoped=true&name=footerMenuExternal&"
import script from "./footerMenuExternal.vue?vue&type=script&lang=js&"
export * from "./footerMenuExternal.vue?vue&type=script&lang=js&"
import style0 from "./footerMenuExternal.vue?vue&type=style&index=0&id=fa4918d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4918d6",
  null
  
)

export default component.exports